import React from 'react';
import { List } from 'react-admin';
import InsightsGrid from '../../components/InsightsGrid';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ExpandableCard from '../../components/cards/ExpandableCard';

import moment from 'moment';

class FeedList extends React.Component {
    render() {
        if (this.props.isLoading) return null;
        return (
            <List title="Here is what you missed..." {...this.props}>
                <ActivityGrid />
            </List>
        );
    }
}

const defaultStyle = {
    width: '100%',
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};

class ActivityGrid extends React.Component {
    render() {
        if (this.props.isLoading) return null;
        const ids = this.props.ids;
        const data = this.props.data;
        const items = this.props.ids
            .map(id => data[id])
            .sort((a, b) => moment(b.timestamp).diff(a.timestamp));
        return <ActivityFeed items={items} />
    }
}

const ActivityFeed = ({ items }) => (
    <div style={{ margin: '1em' }}>
        {items.map((item, index) =>
            <ExpandableCard key={index} content={item} style={defaultStyle} />
        )}
    </div>
);

export default FeedList;


// WEBPACK FOOTER //
// ./src/pages/lists/Feed.js